import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { resetPswThunk } from "../../asyncThunks/auth";

const initialState: defaultState = {
  error: null,
  data: null,
  loading: false,
};

export const resetPassword = createSlice({
  name: "forgotpsw",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetPswThunk.pending, (state, action) => {
      state.error = null;
      state.data = null;
      state.loading = true;
    });
    builder.addCase(resetPswThunk.fulfilled, (state, action) => {
      if (action?.payload?.status?.toLowerCase() === "success") {
        state.error = null;
        state.data = action.payload;
      } else {
        state.error = action?.payload;
        state.data = null;
      }
      state.loading = false;
    });
    builder.addCase(resetPswThunk.rejected, (state, action) => {
      state.error = action.payload;
      state.data = null;
      state.loading = false;
    });
  },
});

export default resetPassword.reducer;
